import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { STOGarantBanner } from '../components/STOGarantBanner';
import { MapPinIcon, UsersIcon, HeartIcon, LeafIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export default function AboutPage() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-240">
      <Header data-id="element-241" />
      <main className="flex-grow" data-id="element-242">
        {/* Hero Section */}
        <section className="relative w-full h-[50vh] bg-cover bg-center" data-id="element-243">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1533105079780-92b9be482077?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80')"
        }} data-id="element-244">
            <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-245"></div>
          </div>
          <div className="container mx-auto px-4 h-full flex items-center justify-center relative z-10" data-id="element-246">
            <div className="text-center text-white max-w-4xl" data-id="element-247">
              <h1 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-248">
                About Experience Hikes
              </h1>
              <p className="text-xl mb-8" data-id="element-249">
                At Experience Hikes, we offer relaxed hiking trips across the
                Mediterranean area where culture, nature and authentic
                experiences come together. No standard routes, but unique
                journeys created with the help of local guides and insiders.
              </p>
              <Link to="/contact" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-8 rounded-md text-center inline-block transition duration-300" data-id="element-250">
                Contact Us
              </Link>
            </div>
          </div>
        </section>
        {/* About Section */}
        <section className="py-16 bg-white w-full" data-id="element-251">
          <div className="container mx-auto px-4" data-id="element-252">
            <div className="max-w-4xl mx-auto text-center" data-id="element-253">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8" data-id="element-254">
                Our Approach
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-255">
                At Experience Hikes, we offer relaxed hiking trips across the
                Mediterranean area where culture, nature and authentic
                experiences come together. No standard routes, but unique
                journeys created with the help of local guides and insiders. You
                don't just see the landscape, you taste, hear and feel the story
                of the region.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-256">
                Our trips are small-scale, personal, and focused on real
                connection with the surroundings. Whether you're hiking through
                the mountains, strolling past vineyards or visiting historic
                artisan villages, with Experience Hikes you travel with depth.
              </p>
            </div>
          </div>
        </section>
        {/* Why Choose Us Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-257">
          <div className="container mx-auto px-4" data-id="element-258">
            <div className="text-center mb-12" data-id="element-259">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-260">
                Why Choose Experience Hikes
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-261">
                What makes our hiking experiences truly special
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto mb-12" data-id="element-262">
              {/* Feature 1 */}
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300" data-id="element-263">
                <div className="text-teal-600 mb-4" data-id="element-264">
                  <MapPinIcon size={40} data-id="element-265" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-266">
                  Local & Authentic
                </h3>
                <p className="text-gray-600" data-id="element-267">
                  We always work with local guides and experts. This gives you
                  access to places, stories, and flavors you'd never discover as
                  a regular tourist.
                </p>
              </div>
              {/* Feature 2 */}
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300" data-id="element-268">
                <div className="text-teal-600 mb-4" data-id="element-269">
                  <HeartIcon size={40} data-id="element-270" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-271">
                  More than just hiking
                </h3>
                <p className="text-gray-600" data-id="element-272">
                  Each trip is a blend of nature, culture, and experience.
                  You're not just walking. You're learning about local
                  traditions, crafts, and everyday life.
                </p>
              </div>
              {/* Feature 3 */}
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300" data-id="element-273">
                <div className="text-teal-600 mb-4" data-id="element-274">
                  <UsersIcon size={40} data-id="element-275" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-276">
                  Small-Scale & Personal
                </h3>
                <p className="text-gray-600" data-id="element-277">
                  We keep it personal. Our groups are small and the atmosphere
                  is relaxed, giving you space for connection, calm, and
                  personal attention.
                </p>
              </div>
              {/* Feature 4 */}
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300" data-id="element-278">
                <div className="text-teal-600 mb-4" data-id="element-279">
                  <LeafIcon size={40} data-id="element-280" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-281">
                  Travel with care
                </h3>
                <p className="text-gray-600" data-id="element-282">
                  We choose destinations and partners who care for nature and
                  culture. That way, your footprint is positive, in every sense.
                </p>
              </div>
            </div>
            <div className="text-center" data-id="element-283">
              <Link to="/contact" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-8 rounded-md text-center inline-block transition duration-300" data-id="element-284">
                Contact Us
              </Link>
            </div>
          </div>
        </section>
        {/* Mission & Vision Section */}
        <section className="py-16 bg-white w-full" data-id="element-285">
          <div className="container mx-auto px-4" data-id="element-286">
            <div className="max-w-4xl mx-auto" data-id="element-287">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-288">
                {/* Mission */}
                <div data-id="element-289">
                  <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-290">
                    Our Mission
                  </h2>
                  <p className="text-lg text-gray-700 leading-relaxed" data-id="element-291">
                    At Experience Hikes, our mission is to create active and
                    varied trips where participants not only enjoy nature, but
                    also truly connect with the local culture and way of life.
                    We always work with local specialists who know the hidden
                    gems, open doors that would otherwise remain closed, and
                    provide an authentic experience full of local color.
                  </p>
                </div>
                {/* Vision */}
                <div data-id="element-292">
                  <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-293">
                    Our Vision
                  </h2>
                  <p className="text-lg text-gray-700 leading-relaxed" data-id="element-294">
                    We believe that travel is more than just moving around, it's
                    a way to discover new worlds, connect deeply, and learn
                    through all your senses. Experience Hikes aims to offer
                    travelers a sustainable and personal way to experience the
                    richness of the Mediterranean area, with respect for people,
                    nature, and stories.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Meet the Owners Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-295">
          <div className="container mx-auto px-4" data-id="element-296">
            <div className="text-center mb-12" data-id="element-297">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-298">
                Meet the Team
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-299">
                The passionate people behind Experience Hikes
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-300">
              {/* Ellen */}
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-301">
                <div className="h-80 overflow-hidden" data-id="element-302">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cYjpEVbCRJwcquc97WJxu9/Scherm%C2%ADafbeelding_2025-07-16_om_11.10.21.png" alt="Ellen - Founder of Experience Hikes" className="w-full h-full object-cover" data-id="element-303" />
                </div>
                <div className="p-6" data-id="element-304">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-305">
                    Ellen
                  </h3>
                  <h4 className="text-teal-600 font-semibold mb-4" data-id="element-306">Founder</h4>
                  <p className="text-gray-700 mb-4" data-id="element-307">
                    My name is Ellen and my passion is to take people to places
                    that I have discovered and became enthusiastic about. I do
                    this in addition to my regular government job. For almost 20
                    years I have co-organized trips in Egypt and Sudan. Although
                    this phase in my life ended, the travel organization blood
                    crawled where it couldn't go and during a holiday on the
                    beautiful island of Zakynthos I was inspired to shift my
                    focus to that and started developing nature trips there.
                  </p>
                  <p className="text-gray-700" data-id="element-308">
                    Together with a local guide with the same passion for the
                    overwhelming nature, I have now developed and successfully
                    carried out several hiking trips. Do you want to follow me
                    in my wanderlust and the products that arise from it? Let me
                    know and you will receive my updates a few times a year!
                  </p>
                </div>
              </div>
              {/* Aisha */}
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-309">
                <div className="h-80 overflow-hidden" data-id="element-310">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/59pmKgLXK8NxuvHPb87TXJ/Scherm%C2%ADafbeelding_2025-07-16_om_11.10.28.png" alt="Aisha - Travel & Hospitality Manager" className="w-full h-full object-cover" data-id="element-311" />
                </div>
                <div className="p-6" data-id="element-312">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-313">
                    Aisha
                  </h3>
                  <h4 className="text-teal-600 font-semibold mb-4" data-id="element-314">
                    Travel & Hospitality Manager
                  </h4>
                  <p className="text-gray-700 mb-4" data-id="element-315">
                    My name is Aisha, I am 24 years old and I am Ellen's
                    daughter. I recently finished my study Travel & hospitality
                    manager. I started working with Ellen on Experience Hikes
                    because I'm passionate about creating meaningful experiences
                    that connect people to new cultures, places, and stories.
                  </p>
                  <p className="text-gray-700" data-id="element-316">
                    Helping others discover the beauty and diversity of the
                    world, while contributing to the local communities we work
                    with. Growing up, I saw how dedicated Ellen was to creating
                    memorable trips for people, and it inspired me to get
                    involved. By working together, I can bring a fresh
                    perspective and help expand the business, while continuing
                    the family tradition of curating unique and meaningful
                    journeys for travelers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <STOGarantBanner data-id="element-317" />
      </main>
      <Footer data-id="element-318" />
    </div>;
}